import DOMPurify from 'isomorphic-dompurify';
import MarkdownIt from 'markdown-it';

import { cn } from '@lcsc-ui/lib/utils';

const md = new MarkdownIt();

const MarkdownRenderer = ({ className, content }) => {
  const html = md.render(content);
  const cleanHtml = DOMPurify.sanitize(html);

  return (
    <div
      className={cn('markdown-container prose !max-w-none text-[14px]', className)}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};

export default MarkdownRenderer;
